import { Injectable } from '@angular/core';
import type { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MissingTranslationHandlerService implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    let translatedValue: string;
    if (params.interpolateParams) {
      translatedValue = params.interpolateParams['defaultValue'];
    }
    return translatedValue ?? params.key.split('.').pop();
  }
}
